<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <h4>Are you sure you want to generate a new password for the agent with username <i>{{data.agent.username}}</i>
    associated to machine with Serial number <i>{{data.machine?.serialNumber}}</i> ? </h4>
  <div *ngIf="pwdGenerated" class="generatedPwdMessage" >The generated password is <i><strong>{{pwdGenerated}}</strong></i></div>
  <mat-error *ngIf="errorMsg">The password generation was not succesful</mat-error>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button cdkFocusInitial (click)="onConfirm()">Yes</button>
  <button mat-raised-button (click)="onDismiss()">Close</button>
</mat-dialog-actions>

